import MyGoogleMap from 'javascripts/modules/google-map';

class LocationMap {

	constructor(){
		this._init();
	}

	_init(){
	  const map = new MyGoogleMap('location-map');
	}

}

export const locationMap = new LocationMap();